import {
  TERM_FREQUENCY_HALF_YEARLY,
  TERM_FREQUENCY_MONTHLY,
  TERM_FREQUENCY_QUARTERLY,
  TERM_FREQUENCY_YEARLY
} from '@termquote/constants';

/**
 * For Term insurance
 * Convert yearly values to monthly values assumes all
 * values returned from apis must be yearly values
 *
 * @param value
 * @param frequency
 */
export const getFrequencyValue = (value: number, decimalPlaces = 0) => {
  return value.toLocaleString('en-IN', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
    style: 'currency',
    currency: 'INR'
  });
};

export const getTaxBenefitAmount = (premium: number, freq?: string) => {
  let finalPremium = premium;
  if (!freq || freq === TERM_FREQUENCY_YEARLY) {
    finalPremium = premium;
  } else if (freq === TERM_FREQUENCY_MONTHLY) {
    finalPremium = premium * 12;
  } else if (freq === TERM_FREQUENCY_QUARTERLY) {
    finalPremium = premium * 4;
  } else if (freq === TERM_FREQUENCY_HALF_YEARLY) {
    const twoHalfs = premium * 2;
    finalPremium = twoHalfs;
  }
  return (Math.min(finalPremium, 150000) * 0.3).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'INR'
  });
};

/**
 * For Health insurance
 * Return the value in inr format
 *
 * @param value
 * @param frequency
 */
export const getHealthFrequencyValue = (value: number, decimalPlaces = 0) => {
  return value?.toLocaleString('en-IN', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
    style: 'currency',
    currency: 'INR'
  });
};

export const heightInCms = (feet: number, inches: number) => {
  return feet * 30.48 + inches * 2.54;
};

export const getBMI = (weight: number, heightFeet: number, heightInches: number) => {
  const heighInMts = heightInCms(heightFeet, heightInches) / 100;
  return parseFloat((weight / (heighInMts * heighInMts)).toFixed(2));
};

export const assessBMIForCompanion = (
  weight: number,
  heightFeet: number,
  heightInches: number
) => {
  const bmi = getBMI(weight, heightFeet, heightInches);
  return bmi >= 15 && bmi <= 37;
};

export const closestMultiple = (n: number, x: number): number => {
  if (x > n) return x;
  n = n + x / 2;
  n = n - (n % x);
  return n;
};
